import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";
import { setPrivileges, setProgress, setUserRoles, setUsers, setUserGroups, setApprovalList, setTrainingsList } from "./adminSlice";

function* getPriveleges(event: any) {
  let progress: any = true;
  yield put(setProgress(progress));
  try {
    const response = yield axios.get('/privilege_data', {
      ...event.payload
    });
    yield put(setPrivileges(response.data));
    // const payload = {
    //   message: "This is the toast message from saga file",
    //   // actionName: "Click me",
    //   variant: "success",
    //   // actionOnClick: () => {alert("alert")}
    // }
    // yield put({ type: "GLOBAL_TOAST_OPEN", payload })
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* savePrivelege(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/privilege_data`, {
      ...(event.payload ?? {})
    });
    yield call(getPriveleges, { payload: event.payload })
    let successMsg = "Create privilege executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* updatePrivelege(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/privilege_data/update`, {
      ...(event.payload ?? {})
    });
    // console.log("here are the response  - - - --", response);
    yield call(getPriveleges, { payload: event.payload })
    let successMsg = "Update privilege executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (err: any) {
    console.error('API error:', err);
    let errMsg = err.message ? err.message : err.error;
    yield call(callToastMessage, errMsg, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* getUserRoles(event: any) {
  let progress: any = true;
  yield put(setProgress(progress));
  try {
    const response = yield axios.get('/roles_data', {
      ...event.payload
    });
    yield put(setUserRoles(response.data));
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* saveUserRoles(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/roles_data`, {
      ...(event.payload ?? {})
    });
    yield call(getUserRoles, { payload: event.payload })
    let successMsg = "Create role executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* updateUserRoles(event) {
  let progress: any = true;
  console.log("event.payloadevent.payload", event.payload);
  
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/roles_data/update`, {
      ...(event.payload ?? {})
    });
    yield call(getUserRoles, { payload: event.payload })
    let successMsg = "Update role executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (err: any) {
    console.error('API error:', err);
    let errMsg = err.response ? err.response.data.error : err.error;
    yield call(callToastMessage, errMsg, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* getUsers(event: any) {
  let progress: any = true;
  yield put(setProgress(progress));
  try {
    const response = yield axios.get('/users', {
      ...event.payload
    });
    yield put(setUsers(response.data));
    // let successMsg = "All users have been successfully retrieved."
    // yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* saveUsers(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/users`, {
      ...(event.payload ?? {})
    });
    yield call(getUsers, { payload: event.payload })
    let successMsg = "Create user executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* updateUsers(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));

    const response = yield call(axios.post, `/users/update`, {
      ...(event.payload ?? {})
    });
    yield call(getUsers, { payload: event.payload })
    let successMsg = "Update user executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error:', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* getAllUserGroups(event) {
  let progress: any = true;
  try{
    yield put(setProgress(progress));
    const response = yield call(axios.get, '/group_data',{
      ...event.payload
    });
    yield put(setUserGroups(response.data));
    // let successMsg = "All groups have been successfully retrieved."
    // yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error: ', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* saveUserGroup(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));
    const response = yield call(axios.post, `/group_data`, {
      ...(event.payload ?? {})
    });
    yield call(getAllUserGroups, { payload: event.payload })
    let successMsg = "Create user group executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (error: any) {
    console.error('API error: ', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* updateUserGroup(event) {
  let progress: any = true;
  try {
    yield put(setProgress(progress));
    const response = yield call(axios.put, `/group_data/update`, {
      ...(event.payload ?? {})
    });
    yield call(getAllUserGroups, { payload: event.payload })
    let successMsg = "Update user group executed successfully"
    yield call(callToastMessage, successMsg, "success");
  } catch (err: any) {
    console.error('API error: ', err);
    let errMsg = err.response ? err.response.data.error : err.error;
    yield call(callToastMessage, errMsg, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* getAllApprovals(event) {
  let progress: any = true;
  try{
    yield put(setProgress(progress));
    const response = yield call(axios.get, '/approvalList',{
      ...event.payload
    });
    yield put(setApprovalList(response.data));
  } catch (error: any) {
    console.error('API error: ', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* getTrainingsList(event) {
  let progress: any = true;
  try{
    yield put(setProgress(progress));
    const response = yield call(axios.get, '/training/list',{
      ...event.payload
    });
    yield put(setTrainingsList(response?.data?.data ?? []));
  } catch (error: any) {
    console.error('API error: ', error);
    yield call(callToastMessage, error?.message, "error");
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}
function* addNewTrainingDocument(event) {
  let progress: any = true;
  const { file, workspaceId } = event.payload;
  try {
    let formData = new FormData();
    formData.append('file', file);

    yield put(setProgress(progress));

    const response = yield call(axios.post, `/training/add`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if(response?.data) {
      let successMsg = "Training document added successfully"
      yield call(callToastMessage, successMsg, "success");
      yield call(getTrainingsList, {
        payload: event.payload
      })
    }
  } catch (error) {
    console.error('API error:', error);
  } finally {
    progress = false;
    yield put(setProgress(progress));
  }
}

function* callToastMessage(msg, status) {
  const payload = {
    message: msg, // Use the 'msg' parameter to set the message dynamically
    variant: status, // Use the 'status' parameter to set the variant dynamically
    // You can uncomment and use the following if you need an action button on the toast
    // actionName: "Click me",
    // actionOnClick: () => { alert("Clicked!") }
  };
  yield put({ type: "GLOBAL_TOAST_OPEN", payload });
}

export function* adminSaga() {
  yield takeEvery("GET_PRIVILEGES", getPriveleges);
  yield takeEvery("SAVE_PRIVILEGES", savePrivelege);
  yield takeEvery("UPDATE_PRIVILEGES", updatePrivelege);

  yield takeEvery("GET_USER_ROLES", getUserRoles);
  yield takeEvery("SAVE_USER_ROLE", saveUserRoles);
  yield takeEvery("UPDATE_USER_ROLE", updateUserRoles);

  yield takeEvery("GET_USERS", getUsers);
  yield takeEvery("SAVE_USERS", saveUsers);
  yield takeEvery("UPDATE_USERS", updateUsers);
  // yield takeEvery("SAVE_NEW_USERS", updateUsers);SAVE_NEW_USERS

  yield takeEvery("GET_ALL_GROUPS", getAllUserGroups)
  yield takeEvery("SAVE_USER_GROUPS", saveUserGroup)
  yield takeEvery("UPDATE_USER_GROUPS", updateUserGroup)

  yield takeEvery("GET_APPROVALS", getAllApprovals);
  yield takeEvery("GET_TRAININGS_LIST", getTrainingsList);
  yield takeEvery("ADD_NEW_TRAININGS_DOCUMENT", addNewTrainingDocument);

}